<template>
  <div class="PuceReport">

    <div class="PuceReport_top">
      <el-form :model="ruleForm" ref="ruleForm" :inline="true" class="demo-form-inline" style="padding: 10px;">
        <el-form-item :label="$t('original.Release_theme')">
          <el-input :placeholder="$t('original.Release_theme')" v-model="ruleForm.PublishSubject"></el-input>
        </el-form-item>

        <el-form-item :label="$t('original.Name_of_Company')">
          <!-- <el-cascader @keydown.enter.native="seachEnterFun" filterable @blur="blur"  @input.native="iptChange" ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" v-model="ruleForm.DeptID" :options="options" :props="{ checkStrictly: true }" clearable></el-cascader> -->
          <el-cascader filterable ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" v-model="DeptIDss"
            :options="options" :props="{ checkStrictly: true }" clearable></el-cascader>
        </el-form-item>



        <el-form-item :label="$t('original.grade')">
          <el-select v-model="ruleForm.NianJI" :placeholder="$t('original.languages3')">
            <el-option v-for="item in gradedata" :key="item.dicKey" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="年份">
          <el-select v-model="ruleForm.yearShare" :placeholder="$t('original.languages3')">
            <el-option v-for="item in gradedata" :key="item.dicKey" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-button type="primary" @click="onSelect()">{{ $t('original.languages153') }}</el-button>
        <el-button type="primary" @click="chongzhi()">{{ $t('original.reset') }}</el-button>
      </el-form>
    </div>
<!-- aaaaaaaaaaaaaaaaaa -->
    <!-- <div style="height: 400px;width: 100%;margin-top:12px">
      <div style="width: 49.5%;height: 100%; float: left;background-color: #fff;"></div>
      <div style="width: 49.5%;height: 100%; float: left;margin-left:1%;">
        <div style="width: 49.5%;height: 100%; float: left;background-color: #fff;"></div>
        <div>
        </div>
        <div style="width: 49.5%;height: 100%; float: left;margin-left:1%;background-color: #fff;"></div>
      </div>
    </div> -->

    <div class="PuceReport_nav" v-loading="load">
      <ul v-if="Published_list.length > 0">
        <li v-for="item in Published_list" :key="item.DicID">
          <img :src="item.Coverurl" alt="" />
          <div class="pl-list-ct">
            <ul>
              <li>
                <h2>{{ item.PublishSubject }}</h2>
              </li>
              <li style="float: right;">
                <p>{{ $t('original.languages70') }}:{{ item.createddate }}
                </p>
              </li>
            </ul>
            <ul class="vdjop">
              <li style="margin-left: 0px;">
                <p :title="item.DeptName"><span class="el-icon-film"></span>{{ item.DeptName }}</p>
              </li>
              <li>
                <p>{{ $t('original.languages71') }}:{{ timeFormatSeconds(item.validstartdate) }}</p>
              </li>
              <li>
                <p>{{ $t('original.languages72') }}:{{ timeFormatSeconds(item.validenddate) }}</p>
              </li>
            </ul>
            
            <ul class="ucdka">
              <li style="width: 300px;">
                <span>{{ $t('original.languages120') }}:</span>
                <el-progress style="width: 200px; display: inline-block; margin-left: 10px;" :stroke-width="26"
                  :percentage="(Number(item.Plan)).toFixed(2)"></el-progress>
              </li>


              <li style="float: right; margin: 0px 10px;">
                <span slot="reference" @click="handleClick(item)" style="color: #e23073;cursor:pointer;"
                  v-if="(item.Nation == 0 || item.Nation == 1) && (item.ReportType == 1 || item.ReportType == 2)">测评报告</span>


                <span slot="reference" @click="ftClick(item)" style="color: #409EFF;cursor:pointer;margin-left:20px"
                  v-if="(item.Nation == 1) && (item.ReportType == 1 || item.ReportType == 2)">访谈报告</span>
              </li>



              <li style="float: right; margin: 0px 10px;"></li>
            </ul>
          </div>
        </li>
      </ul>

      <div style="height: 50px;">
        <el-pagination style="float: right;margin-top: 5px" background layout="total,prev, pager, next" :page-size="5"
          @current-change="handleCurrentChange" :total="total"></el-pagination>
      </div>
    </div>

    <el-dialog class="dialogVisible" :title="$t('original.languages158')" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
      <h2>{{ this.wDeptName }}</h2>
      <h2>{{ $t('original.languages76') }}</h2>
      <el-button type="primary" @click="daochu" style="float: right;">{{ $t('original.languages154') }}</el-button>
      <div>一、{{ $t('original.languages77') }}</div>
      <p>{{ $t('original.languages78') }} {{ whole_report.Practical }} {{ $t('original.languages156') }} ，{{
        $t('original.languages157') }} {{ whole_report.NotJoin }} {{ $t('original.languages156') }}。</p>
      <div>二、 {{ $t('original.languages159') }}</div>
      <table class="tbody1" style="border-collapse:collapse;">
        <thead>
          <tr>
            <th>{{ $t('original.The_serial_number') }}</th>
            <th>{{ $t('original.languages79') }}</th>
            <th>{{ $t('original.languages80') }}</th>
            <th>{{ $t('original.languages81') }}</th>
            <th>{{ $t('original.languages82') }}</th>
            <th>{{ $t('original.languages83') }}</th>
            <th>{{ $t('original.languages84') }}</th>
            <th>{{ $t('original.languages86') }}</th>
            <th>{{ $t('original.languages87') }}</th>
          </tr>
        </thead>
        <tr v-for="item in whole_report.Results" :key="item.index">
          <td>{{ item.no }}</td>
          <td>{{ item.userID }}</td>
          <td>{{ item.depression }}</td>
          <td>{{ item.anxiety }}</td>
          <td>{{ item.stress }}</td>
          <td>{{ item.selfInflict }}</td>
          <td>{{ item.engt }}</td>
          <td>{{ item.suicideRisk }}</td>
          <td>{{ item.attentiveness }}</td>
        </tr>
      </table>
    </el-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      gradedata:[],
      wDeptName: '',
      DeptIDss: '',
      DeptIDguodu: '',
      PublishID: '',
      total: 0,
      shuval: '',//部门搜索的内容
      pisx: true,//判断是否是搜索
      ruleForm: {
        PublishSubject: '',
        DeptID: '',
        NianJI: '',
        yearShare: '',
      },
      whole_report: '',
      dialogVisible: false,
      load: false,
      options: [],//部门数据
      indexval: [],
      Published_list: '',
    };
  },
  mounted() {
    //this.loading(1);
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 1 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.gradedata = res.Data
      }
    })
    this.$Http_Post('/DepartMent/GetDeprtMentByNode', {DeptID:'',content:''}).then((res) => {
      this.options = res.Data;
      this.DeptIDss = res.Data[0].DeptID;
      this.DeptIDguodu = res.Data[0].DeptID;
      if (res.Data) {this.data = res.Data}
    });
    this.$Http_Post('User/DictionaryList').then((res) => { if (res.Code == 200 || res.Code == 0) { this.indexval = res.Data } });
  },
  methods: {
    timeFormatSeconds(time) {
      var d = time ? new Date(time) : new Date();
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hours = d.getHours();
      var min = d.getMinutes();
      var seconds = d.getSeconds();
      if (month < 10) month = '0' + month;
      if (day < 10) day = '0' + day;
      if (hours < 0) hours = '0' + hours;
      if (min < 10) min = '0' + min;
      if (seconds < 10) seconds = '0' + seconds;
      return (year + '-' + month + '-' + day);
    },
    daochu() {
      this.$Http_Post('ScaleIssue/GetInternationalStudentWord', {PublishID: this.PublishID,}).then((res) => {
        // window.location = res.Data;
        if (res.Code == 200 || res.Code == 0) {
          window.open(res.Data, '_blank');
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    seachEnterFun() {
      this.$Http_Post('/DepartMent/GetDeprtMentByNode',{DeptID:'',DeptName:this.shuval}).then((res) => {
        this.options = res.Data;
        document.getElementsByClassName("el-popper").cssText="display:block;";
        if (res.Data) {
          this.data = res.Data;
        }
      });
      this.pisx = false;
    },
    iptChange(val) {
      this.shuval = val.data;
    },
    blur() {
      
    },
    chongzhi() {
      this.ruleForm.PublishSubject = '';
      this.ruleForm.DeptID = '';
      this.ruleForm.NianJI = '';
      this.DeptIDss = this.DeptIDguodu;
      this.ruleForm.yearShare = '';
      this.loading(1);
    },
    handleCurrentChange(val) {//分页点击事件
      this.loading(val);
    },
    onSelect() {
      this.loading(1);
    },
    ftClick(a){
      this.$router.push(
        {
          path: "/measurement/Interview_brief",
          query: {PaperResultID:a.PublishID,ReportType:a.ReportType},
        }
      );
    },
    handleClick(a, b) {
      this.PublishID = a.PublishID;
      let datas = a.ValidStartDate.substring(0, 4);
      if (a.Nation == 1) {
        if (a.ReportType == 2) {//全校

          this.$router.push(
            {
              path: "/measurement/Mental_health_report",
              query: {PaperResultID:a.PublishID,DeptID:this.ruleForm.DeptID,NianJI:this.ruleForm.NianJI,ReportType:a.ReportType},
            }
          );
          
        } else {//新生
          this.$router.push(
            {
              path: "/measurement/Health_report",
              query: {PaperResultID:a.PublishID,DeptID:this.ruleForm.DeptID,NianJI:this.ruleForm.NianJI,ReportType:a.ReportType},
            }
          );
        }
      } else if (a.Nation == 0) {
        this.$Http_Post('ScaleIssue/GetInternationalStudent',{PublishID:a.PublishID,DeptID:this.ruleForm.DeptID,NianJI:this.ruleForm.NianJI}).then((res) => {
          this.dialogVisible = true;
          this.whole_report = res.Data;
          this.wDeptName = res.Data.DeptName;
        })
      }
    },
    loading(val) {
      this.load = true;
      let _this = this;
      this.$Http_Post('ScaleIssue/GetScaleIssueTwo',{pageSize:'5',pageIndex:val,PublishSubject:this.ruleForm.PublishSubject,DeptID:this.ruleForm.DeptID, NianJI:this.ruleForm.NianJI,yearShare:this.ruleForm.yearShare}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.total = res.Counts;
          _this.Published_list = res.Data;
          if (_this.Published_list.length > 0) {
            for (let i = 0; i < _this.Published_list.length; i++) {
              _this.Published_list[i].createddate = _this.Global.formatDate(new Date(_this.Published_list[i].createddate), 'YYYY-MM-DD HH:mm:ss')
            }
          }
          _this.Published_list_num = Number(res.Counts);
          _this.load = false;
        }
      })
      .catch((err) => {
        _this.load=false;
        this.$message({type:'error',message:err.message});
      })
    },
    Selected_to_shut_dow(dt) {
      this.ruleForm.DeptID=dt[dt.length-1];
      this.$refs.wcascader.dropDownVisible=false;
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null;
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i];
          break
        } else if (NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1') {
          this.GetNodeByDeptID(ID, NodeList[i].children);
        }
      }
      return obj;
    },
    bumen(dt) {

      let obj = this.options[0];
      for (let i=0;i<this.options.length;i++) {
        if (this.options[i].DeptID == dt[dt.length - 1]) {
          obj = this.options[i];
          break
        } else if (this.options[i].fuzi && this.options[i].children.length > 0 && this.options[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(
            dt[dt.length - 1],
            this.options[i].children,
          )
        }
      }

      let _this = this;
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1' && this.pisx) {
        obj.children = [{label:this.$t('original.languages22')}];
        this.$Http_Post('/DepartMent/GetDeprtMentByNode',{DeptID:dt[dt.length-1],content:''}).then((res) => {
          if (res.Code==200 || res.Code==0 && res.Data) {
            obj.children = res.Data;
          }
        })
      }

    },
    handleClose(done) {
      this.$confirm(this.$t('original.languages60'))
      .then((_) => {
        done()
      })
      .catch((_) => { })
    },
  },
};
</script>
<style>
.PuceReport .PuceReport_top {
  width: 100%;
  background-color: rgb(255, 255, 255);
}

.PuceReport .PuceReport_nav {
  background-color: rgb(253, 253, 253);
}

.PuceReport .PuceReport_nav>ul>li {
  width: 99.7%;
  height: 162px;
  margin-top: 10px;
  border-bottom: 1px solid #d3d3d3;
}

.PuceReport .PuceReport_nav>ul>li>img {
  margin-top: 20px;
  float: left;
  width: 212px;
  height: 120px;
  margin-left: 20px;
}

.PuceReport .PuceReport_nav>ul>li>.pl-list-ct {
  margin-top: 20px;
  float: right;
  width: calc(100% - 260px);
  height: 120px;
  margin-top: 20px;
  margin-left: 20px;
}

.PuceReport .PuceReport_nav>ul>li ul li {
  font-size: 14px;
  float: left;
  color: rgba(92, 92, 92, 1);
}

.PuceReport .PuceReport_nav>ul>li ul {
  height: 50px;
}

.PuceReport .PuceReport_nav>ul>li ul li h2 {
  font-size: 18px;
}

.PuceReport .PuceReport_nav>ul>li ul li p {
  font-size: 14px;
  color: rgba(92, 92, 92, 1);
  margin-right: 10px;
}

.PuceReport .el-progress-bar__outer {
  height: 6px;
  background-color: rgba(36, 153, 255, 0.1);
  position: relative;
  vertical-align: middle;
  border-radius: 0px !important;
  height: 16px !important;
}

.PuceReport .el-progress-bar__inner {
  border-radius: 0px !important;
  height: 15px !important;
}

.PuceReport .ucdka>li .el-progress__text {
  font-size: 14px !important;
  width: 40px;
}

.PuceReport .el-form-item {
  margin-bottom: 0px
}

.PuceReport .dialogVisible h2 {
  text-align: center;
  margin-top: 10px;
}

.PuceReport .dialogVisible div {
  margin-top: 10px;
  font-size: 16px;
}

.PuceReport .dialogVisible p {
  margin-top: 10px;
  line-height: 30px;
  text-indent: 20px;
  font-size: 16px;
}

.PuceReport .dialogVisible table {
  text-align: center;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 30px;
  border: none;
}

.PuceReport .dialogVisible table td {
  padding: 10px;
  border: 1px rgb(228, 228, 228) solid;
}

.PuceReport .dialogVisible table th {
  padding: 10px;
  border: 1px rgb(228, 228, 228) solid;
  background-color: antiquewhite;
}

.PuceReport .el-form-item {
  margin-left: 20px;
}
</style>